import React from 'react';

import { ExtraSpaceCard } from 'components/ExtraSpaceCard';
import type { ExtraSpaceCardProps } from 'components/ExtraSpaceCard/ExtraSpaceCard';
import { QuoteSpec } from 'components/QuoteSpec';
import type { QuoteSpecProps } from 'components/QuoteSpec/QuoteSpec';

import './quote-spec-section.scss';

interface QuoteSpecSectionRequiredProps {}
interface QuoteSpecSectionOptionalProps {
  title?: string;
  specs?: QuoteSpecProps[];
  extraSpaces?: ExtraSpaceCardProps[];
  type?: 'default' | 'card';
}

// Combined required and optional props to build the full prop interface
export interface QuoteSpecSectionProps extends QuoteSpecSectionRequiredProps, QuoteSpecSectionOptionalProps {}

const QuoteSpecSection: React.FC<QuoteSpecSectionProps> = ({ title, type, specs, extraSpaces }) => {
  return (
    <div className='quote-spec-section'>
      {title && <h3 className='section-title'>{title}</h3>}
      <div className='spec-list'>
        {type === 'card'
          ? extraSpaces?.map((extraSpace) => <ExtraSpaceCard {...extraSpace} />)
          : specs?.map((spec) => <QuoteSpec {...spec} />)}
      </div>
    </div>
  );
};

export default React.memo(QuoteSpecSection);
